import accounting from 'accounting';
import { parseLocale } from '@tesla/parse-locale';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var creditCard = createCommonjsModule(function (module, exports) {
(function (global, factory) {
   factory(exports) ;
}(commonjsGlobal, function (exports) {
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  var _listCacheClear = listCacheClear;

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || (value !== value && other !== other);
  }

  var eq_1 = eq;

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq_1(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  var _assocIndexOf = assocIndexOf;

  /** Used for built-in method references. */
  var arrayProto = Array.prototype;

  /** Built-in value references. */
  var splice = arrayProto.splice;

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  var _listCacheDelete = listCacheDelete;

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  var _listCacheGet = listCacheGet;

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return _assocIndexOf(this.__data__, key) > -1;
  }

  var _listCacheHas = listCacheHas;

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = _assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  var _listCacheSet = listCacheSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = _listCacheClear;
  ListCache.prototype['delete'] = _listCacheDelete;
  ListCache.prototype.get = _listCacheGet;
  ListCache.prototype.has = _listCacheHas;
  ListCache.prototype.set = _listCacheSet;

  var _ListCache = ListCache;

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new _ListCache;
    this.size = 0;
  }

  var _stackClear = stackClear;

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  var _stackDelete = stackDelete;

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  var _stackGet = stackGet;

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  var _stackHas = stackHas;

  var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

  var _freeGlobal = freeGlobal;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = _freeGlobal || freeSelf || Function('return this')();

  var _root = root;

  /** Built-in value references. */
  var Symbol = _root.Symbol;

  var _Symbol = Symbol;

  /** Used for built-in method references. */
  var objectProto = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Built-in value references. */
  var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  var _getRawTag = getRawTag;

  /** Used for built-in method references. */
  var objectProto$1 = Object.prototype;

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString$1 = objectProto$1.toString;

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString$1.call(value);
  }

  var _objectToString = objectToString;

  /** `Object#toString` result references. */
  var nullTag = '[object Null]',
      undefinedTag = '[object Undefined]';

  /** Built-in value references. */
  var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return (symToStringTag$1 && symToStringTag$1 in Object(value))
      ? _getRawTag(value)
      : _objectToString(value);
  }

  var _baseGetTag = baseGetTag;

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
  }

  var isObject_1 = isObject;

  /** `Object#toString` result references. */
  var asyncTag = '[object AsyncFunction]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      proxyTag = '[object Proxy]';

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject_1(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = _baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  var isFunction_1 = isFunction;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = _root['__core-js_shared__'];

  var _coreJsData = coreJsData;

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = (function() {
    var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
    return uid ? ('Symbol(src)_1.' + uid) : '';
  }());

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && (maskSrcKey in func);
  }

  var _isMasked = isMasked;

  /** Used for built-in method references. */
  var funcProto = Function.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return (func + '');
      } catch (e) {}
    }
    return '';
  }

  var _toSource = toSource;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used for built-in method references. */
  var funcProto$1 = Function.prototype,
      objectProto$2 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$1 = funcProto$1.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' +
    funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
    .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  );

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject_1(value) || _isMasked(value)) {
      return false;
    }
    var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
    return pattern.test(_toSource(value));
  }

  var _baseIsNative = baseIsNative;

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  var _getValue = getValue;

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = _getValue(object, key);
    return _baseIsNative(value) ? value : undefined;
  }

  var _getNative = getNative;

  /* Built-in method references that are verified to be native. */
  var Map = _getNative(_root, 'Map');

  var _Map = Map;

  /* Built-in method references that are verified to be native. */
  var nativeCreate = _getNative(Object, 'create');

  var _nativeCreate = nativeCreate;

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
    this.size = 0;
  }

  var _hashClear = hashClear;

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  var _hashDelete = hashDelete;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used for built-in method references. */
  var objectProto$3 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (_nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
  }

  var _hashGet = hashGet;

  /** Used for built-in method references. */
  var objectProto$4 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
  }

  var _hashHas = hashHas;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
    return this;
  }

  var _hashSet = hashSet;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = _hashClear;
  Hash.prototype['delete'] = _hashDelete;
  Hash.prototype.get = _hashGet;
  Hash.prototype.has = _hashHas;
  Hash.prototype.set = _hashSet;

  var _Hash = Hash;

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new _Hash,
      'map': new (_Map || _ListCache),
      'string': new _Hash
    };
  }

  var _mapCacheClear = mapCacheClear;

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value;
    return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
      ? (value !== '__proto__')
      : (value === null);
  }

  var _isKeyable = isKeyable;

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return _isKeyable(key)
      ? data[typeof key == 'string' ? 'string' : 'hash']
      : data.map;
  }

  var _getMapData = getMapData;

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = _getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  var _mapCacheDelete = mapCacheDelete;

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return _getMapData(this, key).get(key);
  }

  var _mapCacheGet = mapCacheGet;

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return _getMapData(this, key).has(key);
  }

  var _mapCacheHas = mapCacheHas;

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = _getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  var _mapCacheSet = mapCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = _mapCacheClear;
  MapCache.prototype['delete'] = _mapCacheDelete;
  MapCache.prototype.get = _mapCacheGet;
  MapCache.prototype.has = _mapCacheHas;
  MapCache.prototype.set = _mapCacheSet;

  var _MapCache = MapCache;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof _ListCache) {
      var pairs = data.__data__;
      if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new _MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  var _stackSet = stackSet;

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new _ListCache(entries);
    this.size = data.size;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = _stackClear;
  Stack.prototype['delete'] = _stackDelete;
  Stack.prototype.get = _stackGet;
  Stack.prototype.has = _stackHas;
  Stack.prototype.set = _stackSet;

  var _Stack = Stack;

  var defineProperty = (function() {
    try {
      var func = _getNative(Object, 'defineProperty');
      func({}, '', {});
      return func;
    } catch (e) {}
  }());

  var _defineProperty$1 = defineProperty;

  /**
   * The base implementation of `assignValue` and `assignMergeValue` without
   * value checks.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function baseAssignValue(object, key, value) {
    if (key == '__proto__' && _defineProperty$1) {
      _defineProperty$1(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
      });
    } else {
      object[key] = value;
    }
  }

  var _baseAssignValue = baseAssignValue;

  /**
   * This function is like `assignValue` except that it doesn't assign
   * `undefined` values.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignMergeValue(object, key, value) {
    if ((value !== undefined && !eq_1(object[key], value)) ||
        (value === undefined && !(key in object))) {
      _baseAssignValue(object, key, value);
    }
  }

  var _assignMergeValue = assignMergeValue;

  /**
   * Creates a base function for methods like `_.forIn` and `_.forOwn`.
   *
   * @private
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {Function} Returns the new base function.
   */
  function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
      var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;

      while (length--) {
        var key = props[fromRight ? length : ++index];
        if (iteratee(iterable[key], key, iterable) === false) {
          break;
        }
      }
      return object;
    };
  }

  var _createBaseFor = createBaseFor;

  /**
   * The base implementation of `baseForOwn` which iterates over `object`
   * properties returned by `keysFunc` and invokes `iteratee` for each property.
   * Iteratee functions may exit iteration early by explicitly returning `false`.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @returns {Object} Returns `object`.
   */
  var baseFor = _createBaseFor();

  var _baseFor = baseFor;

  var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

    buffer.copy(result);
    return result;
  }

  module.exports = cloneBuffer;
  });

  /** Built-in value references. */
  var Uint8Array = _root.Uint8Array;

  var _Uint8Array = Uint8Array;

  /**
   * Creates a clone of `arrayBuffer`.
   *
   * @private
   * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
   * @returns {ArrayBuffer} Returns the cloned array buffer.
   */
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
    return result;
  }

  var _cloneArrayBuffer = cloneArrayBuffer;

  /**
   * Creates a clone of `typedArray`.
   *
   * @private
   * @param {Object} typedArray The typed array to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Object} Returns the cloned typed array.
   */
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }

  var _cloneTypedArray = cloneTypedArray;

  /**
   * Copies the values of `source` to `array`.
   *
   * @private
   * @param {Array} source The array to copy values from.
   * @param {Array} [array=[]] The array to copy values to.
   * @returns {Array} Returns `array`.
   */
  function copyArray(source, array) {
    var index = -1,
        length = source.length;

    array || (array = Array(length));
    while (++index < length) {
      array[index] = source[index];
    }
    return array;
  }

  var _copyArray = copyArray;

  /** Built-in value references. */
  var objectCreate = Object.create;

  /**
   * The base implementation of `_.create` without support for assigning
   * properties to the created object.
   *
   * @private
   * @param {Object} proto The object to inherit from.
   * @returns {Object} Returns the new object.
   */
  var baseCreate = (function() {
    function object() {}
    return function(proto) {
      if (!isObject_1(proto)) {
        return {};
      }
      if (objectCreate) {
        return objectCreate(proto);
      }
      object.prototype = proto;
      var result = new object;
      object.prototype = undefined;
      return result;
    };
  }());

  var _baseCreate = baseCreate;

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  var _overArg = overArg;

  /** Built-in value references. */
  var getPrototype = _overArg(Object.getPrototypeOf, Object);

  var _getPrototype = getPrototype;

  /** Used for built-in method references. */
  var objectProto$5 = Object.prototype;

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

    return value === proto;
  }

  var _isPrototype = isPrototype;

  /**
   * Initializes an object clone.
   *
   * @private
   * @param {Object} object The object to clone.
   * @returns {Object} Returns the initialized clone.
   */
  function initCloneObject(object) {
    return (typeof object.constructor == 'function' && !_isPrototype(object))
      ? _baseCreate(_getPrototype(object))
      : {};
  }

  var _initCloneObject = initCloneObject;

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && typeof value == 'object';
  }

  var isObjectLike_1 = isObjectLike;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]';

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
  }

  var _baseIsArguments = baseIsArguments;

  /** Used for built-in method references. */
  var objectProto$6 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

  /** Built-in value references. */
  var propertyIsEnumerable = objectProto$6.propertyIsEnumerable;

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
    return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
      !propertyIsEnumerable.call(value, 'callee');
  };

  var isArguments_1 = isArguments;

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  var isArray_1 = isArray;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' &&
      value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  var isLength_1 = isLength;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength_1(value.length) && !isFunction_1(value);
  }

  var isArrayLike_1 = isArrayLike;

  /**
   * This method is like `_.isArrayLike` except that it also checks if `value`
   * is an object.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array-like object,
   *  else `false`.
   * @example
   *
   * _.isArrayLikeObject([1, 2, 3]);
   * // => true
   *
   * _.isArrayLikeObject(document.body.children);
   * // => true
   *
   * _.isArrayLikeObject('abc');
   * // => false
   *
   * _.isArrayLikeObject(_.noop);
   * // => false
   */
  function isArrayLikeObject(value) {
    return isObjectLike_1(value) && isArrayLike_1(value);
  }

  var isArrayLikeObject_1 = isArrayLikeObject;

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  var stubFalse_1 = stubFalse;

  var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse_1;

  module.exports = isBuffer;
  });

  /** `Object#toString` result references. */
  var objectTag = '[object Object]';

  /** Used for built-in method references. */
  var funcProto$2 = Function.prototype,
      objectProto$7 = Object.prototype;

  /** Used to resolve the decompiled source of functions. */
  var funcToString$2 = funcProto$2.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

  /** Used to infer the `Object` constructor. */
  var objectCtorString = funcToString$2.call(Object);

  /**
   * Checks if `value` is a plain object, that is, an object created by the
   * `Object` constructor or one with a `[[Prototype]]` of `null`.
   *
   * @static
   * @memberOf _
   * @since 0.8.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   * }
   *
   * _.isPlainObject(new Foo);
   * // => false
   *
   * _.isPlainObject([1, 2, 3]);
   * // => false
   *
   * _.isPlainObject({ 'x': 0, 'y': 0 });
   * // => true
   *
   * _.isPlainObject(Object.create(null));
   * // => true
   */
  function isPlainObject(value) {
    if (!isObjectLike_1(value) || _baseGetTag(value) != objectTag) {
      return false;
    }
    var proto = _getPrototype(value);
    if (proto === null) {
      return true;
    }
    var Ctor = hasOwnProperty$5.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor &&
      funcToString$2.call(Ctor) == objectCtorString;
  }

  var isPlainObject_1 = isPlainObject;

  /** `Object#toString` result references. */
  var argsTag$1 = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag$1 = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag$1 = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag$1] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag$1] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike_1(value) &&
      isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
  }

  var _baseIsTypedArray = baseIsTypedArray;

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  var _baseUnary = baseUnary;

  var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports =  exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && _freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  module.exports = nodeUtil;
  });

  /* Node.js helper references. */
  var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

  var isTypedArray_1 = isTypedArray;

  /**
   * Gets the value at `key`, unless `key` is "__proto__".
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function safeGet(object, key) {
    if (key == '__proto__') {
      return;
    }

    return object[key];
  }

  var _safeGet = safeGet;

  /** Used for built-in method references. */
  var objectProto$8 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

  /**
   * Assigns `value` to `key` of `object` if the existing value is not equivalent
   * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * for equality comparisons.
   *
   * @private
   * @param {Object} object The object to modify.
   * @param {string} key The key of the property to assign.
   * @param {*} value The value to assign.
   */
  function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty$6.call(object, key) && eq_1(objValue, value)) ||
        (value === undefined && !(key in object))) {
      _baseAssignValue(object, key, value);
    }
  }

  var _assignValue = assignValue;

  /**
   * Copies properties of `source` to `object`.
   *
   * @private
   * @param {Object} source The object to copy properties from.
   * @param {Array} props The property identifiers to copy.
   * @param {Object} [object={}] The object to copy properties to.
   * @param {Function} [customizer] The function to customize copied values.
   * @returns {Object} Returns `object`.
   */
  function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});

    var index = -1,
        length = props.length;

    while (++index < length) {
      var key = props[index];

      var newValue = customizer
        ? customizer(object[key], source[key], key, object, source)
        : undefined;

      if (newValue === undefined) {
        newValue = source[key];
      }
      if (isNew) {
        _baseAssignValue(object, key, newValue);
      } else {
        _assignValue(object, key, newValue);
      }
    }
    return object;
  }

  var _copyObject = copyObject;

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  var _baseTimes = baseTimes;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER$1 = 9007199254740991;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER$1 : length;

    return !!length &&
      (type == 'number' ||
        (type != 'symbol' && reIsUint.test(value))) &&
          (value > -1 && value % 1 == 0 && value < length);
  }

  var _isIndex = isIndex;

  /** Used for built-in method references. */
  var objectProto$9 = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray_1(value),
        isArg = !isArr && isArguments_1(value),
        isBuff = !isArr && !isArg && isBuffer_1(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? _baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty$7.call(value, key)) &&
          !(skipIndexes && (
             // Safari 9 has enumerable `arguments.length` in strict mode.
             key == 'length' ||
             // Node.js 0.10 has enumerable non-index properties on buffers.
             (isBuff && (key == 'offset' || key == 'parent')) ||
             // PhantomJS 2 has enumerable non-index properties on typed arrays.
             (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
             // Skip index properties.
             _isIndex(key, length)
          ))) {
        result.push(key);
      }
    }
    return result;
  }

  var _arrayLikeKeys = arrayLikeKeys;

  /**
   * This function is like
   * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * except that it includes inherited enumerable properties.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function nativeKeysIn(object) {
    var result = [];
    if (object != null) {
      for (var key in Object(object)) {
        result.push(key);
      }
    }
    return result;
  }

  var _nativeKeysIn = nativeKeysIn;

  /** Used for built-in method references. */
  var objectProto$a = Object.prototype;

  /** Used to check objects for own properties. */
  var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

  /**
   * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeysIn(object) {
    if (!isObject_1(object)) {
      return _nativeKeysIn(object);
    }
    var isProto = _isPrototype(object),
        result = [];

    for (var key in object) {
      if (!(key == 'constructor' && (isProto || !hasOwnProperty$8.call(object, key)))) {
        result.push(key);
      }
    }
    return result;
  }

  var _baseKeysIn = baseKeysIn;

  /**
   * Creates an array of the own and inherited enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keysIn(new Foo);
   * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
   */
  function keysIn(object) {
    return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
  }

  var keysIn_1 = keysIn;

  /**
   * Converts `value` to a plain object flattening inherited enumerable string
   * keyed properties of `value` to own properties of the plain object.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to convert.
   * @returns {Object} Returns the converted plain object.
   * @example
   *
   * function Foo() {
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.assign({ 'a': 1 }, new Foo);
   * // => { 'a': 1, 'b': 2 }
   *
   * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
   * // => { 'a': 1, 'b': 2, 'c': 3 }
   */
  function toPlainObject(value) {
    return _copyObject(value, keysIn_1(value));
  }

  var toPlainObject_1 = toPlainObject;

  /**
   * A specialized version of `baseMerge` for arrays and objects which performs
   * deep merges and tracks traversed objects enabling objects with circular
   * references to be merged.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {string} key The key of the value to merge.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} mergeFunc The function to merge values.
   * @param {Function} [customizer] The function to customize assigned values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = _safeGet(object, key),
        srcValue = _safeGet(source, key),
        stacked = stack.get(srcValue);

    if (stacked) {
      _assignMergeValue(object, key, stacked);
      return;
    }
    var newValue = customizer
      ? customizer(objValue, srcValue, (key + ''), object, source, stack)
      : undefined;

    var isCommon = newValue === undefined;

    if (isCommon) {
      var isArr = isArray_1(srcValue),
          isBuff = !isArr && isBuffer_1(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray_1(srcValue);

      newValue = srcValue;
      if (isArr || isBuff || isTyped) {
        if (isArray_1(objValue)) {
          newValue = objValue;
        }
        else if (isArrayLikeObject_1(objValue)) {
          newValue = _copyArray(objValue);
        }
        else if (isBuff) {
          isCommon = false;
          newValue = _cloneBuffer(srcValue, true);
        }
        else if (isTyped) {
          isCommon = false;
          newValue = _cloneTypedArray(srcValue, true);
        }
        else {
          newValue = [];
        }
      }
      else if (isPlainObject_1(srcValue) || isArguments_1(srcValue)) {
        newValue = objValue;
        if (isArguments_1(objValue)) {
          newValue = toPlainObject_1(objValue);
        }
        else if (!isObject_1(objValue) || isFunction_1(objValue)) {
          newValue = _initCloneObject(srcValue);
        }
      }
      else {
        isCommon = false;
      }
    }
    if (isCommon) {
      // Recursively merge objects and arrays (susceptible to call stack limits).
      stack.set(srcValue, newValue);
      mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
      stack['delete'](srcValue);
    }
    _assignMergeValue(object, key, newValue);
  }

  var _baseMergeDeep = baseMergeDeep;

  /**
   * The base implementation of `_.merge` without support for multiple sources.
   *
   * @private
   * @param {Object} object The destination object.
   * @param {Object} source The source object.
   * @param {number} srcIndex The index of `source`.
   * @param {Function} [customizer] The function to customize merged values.
   * @param {Object} [stack] Tracks traversed source values and their merged
   *  counterparts.
   */
  function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) {
      return;
    }
    _baseFor(source, function(srcValue, key) {
      if (isObject_1(srcValue)) {
        stack || (stack = new _Stack);
        _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
      }
      else {
        var newValue = customizer
          ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
          : undefined;

        if (newValue === undefined) {
          newValue = srcValue;
        }
        _assignMergeValue(object, key, newValue);
      }
    }, keysIn_1);
  }

  var _baseMerge = baseMerge;

  /**
   * This method returns the first argument it receives.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Util
   * @param {*} value Any value.
   * @returns {*} Returns `value`.
   * @example
   *
   * var object = { 'a': 1 };
   *
   * console.log(_.identity(object) === object);
   * // => true
   */
  function identity(value) {
    return value;
  }

  var identity_1 = identity;

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  var _apply = apply;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeMax = Math.max;

  /**
   * A specialized version of `baseRest` which transforms the rest array.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @param {Function} transform The rest array transform.
   * @returns {Function} Returns the new function.
   */
  function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
    return function() {
      var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);

      while (++index < length) {
        array[index] = args[start + index];
      }
      index = -1;
      var otherArgs = Array(start + 1);
      while (++index < start) {
        otherArgs[index] = args[index];
      }
      otherArgs[start] = transform(array);
      return _apply(func, this, otherArgs);
    };
  }

  var _overRest = overRest;

  /**
   * Creates a function that returns `value`.
   *
   * @static
   * @memberOf _
   * @since 2.4.0
   * @category Util
   * @param {*} value The value to return from the new function.
   * @returns {Function} Returns the new constant function.
   * @example
   *
   * var objects = _.times(2, _.constant({ 'a': 1 }));
   *
   * console.log(objects);
   * // => [{ 'a': 1 }, { 'a': 1 }]
   *
   * console.log(objects[0] === objects[1]);
   * // => true
   */
  function constant(value) {
    return function() {
      return value;
    };
  }

  var constant_1 = constant;

  /**
   * The base implementation of `setToString` without support for hot loop shorting.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var baseSetToString = !_defineProperty$1 ? identity_1 : function(func, string) {
    return _defineProperty$1(func, 'toString', {
      'configurable': true,
      'enumerable': false,
      'value': constant_1(string),
      'writable': true
    });
  };

  var _baseSetToString = baseSetToString;

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeNow = Date.now;

  /**
   * Creates a function that'll short out and invoke `identity` instead
   * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
   * milliseconds.
   *
   * @private
   * @param {Function} func The function to restrict.
   * @returns {Function} Returns the new shortable function.
   */
  function shortOut(func) {
    var count = 0,
        lastCalled = 0;

    return function() {
      var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);

      lastCalled = stamp;
      if (remaining > 0) {
        if (++count >= HOT_COUNT) {
          return arguments[0];
        }
      } else {
        count = 0;
      }
      return func.apply(undefined, arguments);
    };
  }

  var _shortOut = shortOut;

  /**
   * Sets the `toString` method of `func` to return `string`.
   *
   * @private
   * @param {Function} func The function to modify.
   * @param {Function} string The `toString` result.
   * @returns {Function} Returns `func`.
   */
  var setToString = _shortOut(_baseSetToString);

  var _setToString = setToString;

  /**
   * The base implementation of `_.rest` which doesn't validate or coerce arguments.
   *
   * @private
   * @param {Function} func The function to apply a rest parameter to.
   * @param {number} [start=func.length-1] The start position of the rest parameter.
   * @returns {Function} Returns the new function.
   */
  function baseRest(func, start) {
    return _setToString(_overRest(func, start, identity_1), func + '');
  }

  var _baseRest = baseRest;

  /**
   * Checks if the given arguments are from an iteratee call.
   *
   * @private
   * @param {*} value The potential iteratee value argument.
   * @param {*} index The potential iteratee index or key argument.
   * @param {*} object The potential iteratee object argument.
   * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
   *  else `false`.
   */
  function isIterateeCall(value, index, object) {
    if (!isObject_1(object)) {
      return false;
    }
    var type = typeof index;
    if (type == 'number'
          ? (isArrayLike_1(object) && _isIndex(index, object.length))
          : (type == 'string' && index in object)
        ) {
      return eq_1(object[index], value);
    }
    return false;
  }

  var _isIterateeCall = isIterateeCall;

  /**
   * Creates a function like `_.assign`.
   *
   * @private
   * @param {Function} assigner The function to assign values.
   * @returns {Function} Returns the new assigner function.
   */
  function createAssigner(assigner) {
    return _baseRest(function(object, sources) {
      var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;

      customizer = (assigner.length > 3 && typeof customizer == 'function')
        ? (length--, customizer)
        : undefined;

      if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
        customizer = length < 3 ? undefined : customizer;
        length = 1;
      }
      object = Object(object);
      while (++index < length) {
        var source = sources[index];
        if (source) {
          assigner(object, source, index, customizer);
        }
      }
      return object;
    });
  }

  var _createAssigner = createAssigner;

  /**
   * This method is like `_.assign` except that it recursively merges own and
   * inherited enumerable string keyed properties of source objects into the
   * destination object. Source properties that resolve to `undefined` are
   * skipped if a destination value exists. Array and plain object properties
   * are merged recursively. Other objects and value types are overridden by
   * assignment. Source objects are applied from left to right. Subsequent
   * sources overwrite property assignments of previous sources.
   *
   * **Note:** This method mutates `object`.
   *
   * @static
   * @memberOf _
   * @since 0.5.0
   * @category Object
   * @param {Object} object The destination object.
   * @param {...Object} [sources] The source objects.
   * @returns {Object} Returns `object`.
   * @example
   *
   * var object = {
   *   'a': [{ 'b': 2 }, { 'd': 4 }]
   * };
   *
   * var other = {
   *   'a': [{ 'c': 3 }, { 'e': 5 }]
   * };
   *
   * _.merge(object, other);
   * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
   */
  var merge = _createAssigner(function(object, source, srcIndex) {
    _baseMerge(object, source, srcIndex);
  });

  var merge_1 = merge;

  var _cardTypes;
  var VISA = 'VISA';
  var MASTERCARD = 'MASTERCARD';
  var AMERICANEXPRESS = 'AMERICANEXPRESS';
  var DINERSCLUB = 'DINERSCLUB';
  var DISCOVER = 'DISCOVER';
  var JCB = 'JCB';
  var UNIONPAY = 'UNIONPAY';
  var MAESTRO = 'MAESTRO';
  var testOrder = [VISA, MASTERCARD, AMERICANEXPRESS, DINERSCLUB, DISCOVER, JCB, UNIONPAY, MAESTRO];
  var defaultOptions = {
    cardTypes: (_cardTypes = {}, _defineProperty(_cardTypes, VISA, {
      cardType: VISA,
      cardPattern: /^4\d*$/,
      partialPattern: /^4/,
      cvvPattern: /^\d{3}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 8, 12],
      lengths: [16, 18, 19]
    }), _defineProperty(_cardTypes, MASTERCARD, {
      cardType: MASTERCARD,
      cardPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
      partialPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27[0-1]|2720)$/,
      cvvPattern: /^\d{3}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 8, 12],
      lengths: [16]
    }), _defineProperty(_cardTypes, AMERICANEXPRESS, {
      cardType: AMERICANEXPRESS,
      cardPattern: /^3[47]\d*$/,
      partialPattern: /^(3|34|37)$/,
      cvvPattern: /^\d{4}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 10],
      lengths: [15]
    }), _defineProperty(_cardTypes, DINERSCLUB, {
      cardType: DINERSCLUB,
      cardPattern: /^3(0[0-5]|[689])\d*$/,
      partialPattern: /^(3|3[0689]|30[0-5])$/,
      cvvPattern: /^\d{3}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 10],
      lengths: [14]
    }), _defineProperty(_cardTypes, DISCOVER, {
      cardType: DISCOVER,
      cardPattern: /^(6011|65|64[4-9])\d*$/,
      partialPattern: /^(6|60|601|6011|65|64|64[4-9])$/,
      cvvPattern: /^\d{3}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 8, 12],
      lengths: [16, 19]
    }), _defineProperty(_cardTypes, JCB, {
      cardType: JCB,
      cardPattern: /^(2131|1800|35)\d*$/,
      partialPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
      cvvPattern: /^\d{3}$/,
      luhn: true,
      expDate: true,
      gaps: [4, 8, 12],
      lengths: [16]
    }), _defineProperty(_cardTypes, UNIONPAY, {
      cardType: UNIONPAY,
      cardPattern: /^62\d*$/,
      partialPattern: /^(6|62)$/,
      cvvPattern: /^\d{0,4}$/,
      luhn: false,
      expDate: false,
      gaps: [4, 8, 12],
      lengths: [16, 17, 18, 19]
    }), _defineProperty(_cardTypes, MAESTRO, {
      cardType: MAESTRO,
      cardPattern: /^5[06-9]\d*$/,
      partialPattern: /^(5|5[06-9]|6\d*)$/,
      cvvPattern: /^\d{3}$/,
      luhn: false,
      expDate: false,
      gaps: [4, 8, 12],
      lengths: [12, 13, 14, 15, 16, 17, 18, 19]
    }), _cardTypes),
    expiryMonths: {
      min: 1,
      max: 12
    },
    expiryYears: {
      min: 1900,
      max: 2200
    },
    schema: {
      cardType: 'cardType',
      number: 'number',
      expiryMonth: 'expiryMonth',
      expiryYear: 'expiryYear',
      cvv: 'cvv'
    }
  };

  function clone(x) {
    if (!x) {
      return null;
    }

    var partialPattern = x.partialPattern.source;
    var cardPattern = x.cardPattern.source;
    var dupe = JSON.parse(JSON.stringify(x));
    dupe.partialPattern = partialPattern;
    dupe.cardPattern = cardPattern;
    return dupe;
  }

  function setupCardTypeAliases(type, aliases) {
    for (var i = 0; i < aliases.length; i += 1) {
      defaultOptions.cardTypes[aliases[i]] = defaultOptions.cardTypes[type];
    }
  } // Setup Aliases


  setupCardTypeAliases('VISA', ['vc', 'VC', 'visa']);
  setupCardTypeAliases('MASTERCARD', ['mc', 'MC', 'mastercard', 'master card', 'MASTER CARD']);
  setupCardTypeAliases('AMERICANEXPRESS', ['ae', 'AE', 'ax', 'AX', 'amex', 'AMEX', 'american express', 'AMERICAN EXPRESS']);
  setupCardTypeAliases('DINERSCLUB', ['dinersclub']);
  setupCardTypeAliases('DISCOVER', ['dc', 'DC', 'discover']);
  setupCardTypeAliases('JCB', ['jcb']);
  setupCardTypeAliases('UNIONPAY', ['up', 'UP', 'UNIONPAY']); // Store original defaults. This must happen after aliases are setup

  var originalDefaults = merge_1({}, defaultOptions);

  var sanitizeNumberString = function sanitizeNumberString(number) {
    if (typeof number !== 'string') {
      return '';
    }

    return number.replace(/[^\d]/g, '');
  };
  var luhn = function luhn(number, type, options) {
    // Source - https://gist.github.com/DiegoSalazar/4075533
    var settings = merge_1({}, defaultOptions.cardTypes, options);

    var patterns = settings[type];

    if (!patterns) {
      return false;
    }

    if (!patterns.luhn) {
      return true;
    }

    if (/[^\d]+/.test(number) || typeof number !== 'string' || !number) {
      return false;
    }

    var nCheck = 0;
    var cDigit = '0';
    var nDigit = 0;
    var bEven = false;
    var value = number.replace(/\D/g, '');

    for (var n = value.length - 1; n >= 0; n -= 1) {
      cDigit = value.charAt(n);
      nDigit = parseInt(cDigit, 10);

      if (bEven) {
        nDigit *= 2;

        if (nDigit > 9) {
          nDigit -= 9;
        }
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  };
  var doesNumberMatchType = function doesNumberMatchType(number, type, options) {
    var settings = merge_1({}, defaultOptions.cardTypes, options);

    var patterns = settings[type];

    if (!patterns) {
      return false;
    }

    return patterns.cardPattern.test(number);
  };
  var isValidCardNumber = function isValidCardNumber(number, type, options) {
    return doesNumberMatchType(number, type, options) && luhn(number, type, options);
  };
  var isValidExpiryMonth = function isValidExpiryMonth(month, type, options) {
    var patterns = merge_1({}, defaultOptions.expiryMonths, options);

    var settings = merge_1({}, defaultOptions.cardTypes, options);

    var cardSetting = settings[type] || {};

    if (patterns && !cardSetting.expDate) {
      return true;
    }

    if (typeof month === 'string' && month.length > 2) {
      return false;
    }

    var value = ~~month; // eslint-disable-line no-bitwise

    return value >= patterns.min && value <= patterns.max;
  };
  var isValidExpiryYear = function isValidExpiryYear(year, type, options) {
    var patterns = merge_1({}, defaultOptions.expiryYears, options);

    var settings = merge_1({}, defaultOptions.cardTypes, options);

    var cardSetting = settings[type] || {};

    if (patterns && !cardSetting.expDate) {
      return true;
    }

    if (typeof year === 'string' && year.length !== 4) {
      return false;
    }

    var value = ~~year; // eslint-disable-line no-bitwise

    return value >= patterns.min && value <= patterns.max;
  };
  var doesCvvMatchType = function doesCvvMatchType(number, type, options) {
    var settings = merge_1({}, defaultOptions.cardTypes, options);

    var patterns = settings[type];

    if (!patterns) {
      return false;
    }

    return patterns.cvvPattern.test(number);
  };
  var isExpired = function isExpired(month, year) {
    var monthVal = ~~month; // eslint-disable-line no-bitwise

    var yearVal = ~~year; // eslint-disable-line no-bitwise
    // Cards are good until the end of the month
    // http://stackoverflow.com/questions/54037/credit-card-expiration-dates-inclusive-or-exclusive

    var expiration = new Date(yearVal, monthVal);
    return Date.now() >= expiration.getTime();
  };
  var validate = function validate(card, options) {
    var cardVal = card || {};

    var settings = merge_1({}, defaultOptions, options);

    var schema = settings.schema;
    var cardType = cardVal[schema.cardType];
    var number = sanitizeNumberString(cardVal[schema.number]);
    var expiryMonth = cardVal[schema.expiryMonth];
    var expiryYear = cardVal[schema.expiryYear];
    var cvv = sanitizeNumberString(cardVal[schema.cvv]);
    var customValidationFn = settings.customValidation;
    var customValidation; // Optional custom validation

    if (typeof customValidationFn === 'function') {
      customValidation = customValidationFn(cardVal, settings);
    }

    return {
      card: cardVal,
      validCardNumber: isValidCardNumber(number, cardType, settings.cardTypes),
      validExpiryMonth: isValidExpiryMonth(expiryMonth, cardType, settings.expiryMonths),
      validExpiryYear: isValidExpiryYear(expiryYear, cardType, settings.expiryYears),
      validCvv: doesCvvMatchType(cvv, cardType, settings.cardTypes),
      isExpired: isExpired(expiryMonth, expiryYear),
      customValidation: customValidation
    };
  };
  var getTypes = function getTypes(number) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    var settings = merge_1({}, defaultOptions, options);

    var cardTypes = settings.cardTypes;
    var cardNumber = sanitizeNumberString(number);
    var type;
    var value;
    var prefixResults = [];
    var exactResults = [];

    for (var i = 0; i < testOrder.length; i += 1) {
      type = testOrder[i];
      value = cardTypes[type];

      if (cardNumber.length !== 0) {
        if (value.cardPattern.test(cardNumber)) {
          exactResults.push(clone(value));
        } else if (value.partialPattern.test(cardNumber)) {
          prefixResults.push(clone(value));
        }
      } else {
        prefixResults.push(clone(value));
      }
    }

    return exactResults.length ? exactResults : prefixResults;
  };
  var getType = function getType(number) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var cardData = getTypes(number, options);
    return cardData.length ? cardData[0].cardType : null;
  };
  var getTypeInfo = function getTypeInfo(type) {
    return clone(defaultOptions.cardTypes[type]);
  };
  var defaults = function defaults(options, overwrite) {
    var optionsVal = options || {};

    if (overwrite === true) {
      defaultOptions = merge_1({}, optionsVal);
    } else {
      defaultOptions = merge_1({}, defaultOptions, optionsVal);
    }

    return defaultOptions;
  };
  var reset = function reset() {
    defaultOptions = merge_1({}, originalDefaults);
    return defaultOptions;
  };
  var index = {
    sanitizeNumberString: sanitizeNumberString,
    luhn: luhn,
    doesNumberMatchType: doesNumberMatchType,
    isValidCardNumber: isValidCardNumber,
    isValidExpiryMonth: isValidExpiryMonth,
    isValidExpiryYear: isValidExpiryYear,
    isExpired: isExpired,
    doesCvvMatchType: doesCvvMatchType,
    validate: validate,
    getTypes: getTypes,
    getType: getType,
    getTypeInfo: getTypeInfo,
    defaults: defaults,
    reset: reset
  };

  exports.default = index;
  exports.defaults = defaults;
  exports.doesCvvMatchType = doesCvvMatchType;
  exports.doesNumberMatchType = doesNumberMatchType;
  exports.getType = getType;
  exports.getTypeInfo = getTypeInfo;
  exports.getTypes = getTypes;
  exports.isExpired = isExpired;
  exports.isValidCardNumber = isValidCardNumber;
  exports.isValidExpiryMonth = isValidExpiryMonth;
  exports.isValidExpiryYear = isValidExpiryYear;
  exports.luhn = luhn;
  exports.reset = reset;
  exports.sanitizeNumberString = sanitizeNumberString;
  exports.validate = validate;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
});

var CreditCard = /*@__PURE__*/getDefaultExportFromCjs(creditCard);

var formats = {
    fr: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: ' ',
    },
    AD: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    cs_CZ: {
        currency: 'CZK',
        decimal: ',',
        format: '%v %s',
        symbol: 'Kč',
        thousand: ' ',
    },
    en_AE: {
        currency: 'AED',
        decimal: '.',
        format: '%s %v',
        symbol: 'AED',
        thousand: ',',
    },
    en_AT: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    de_AT: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_AU: {
        currency: 'AUD',
        format: '%s%v',
        symbol: '$',
        symbol_foreign: 'AU$',
    },
    en_BE: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    fr_BE: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    nl_BE: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_CA: {
        currency: 'CAD',
        symbol: '$',
        symbol_foreign: 'CA$',
    },
    de_CH: {
        currency: 'CHF',
        decimal: ',',
        format: '%s %v',
        symbol: 'CHF',
        thousand: "'",
    },
    fr_CA: {
        currency: 'CAD',
        decimal: ',',
        format: '%v %s',
        symbol: '$',
        symbol_foreign: 'CA$',
        thousand: ' ',
    },
    fr_CH: {
        currency: 'CHF',
        decimal: ',',
        format: '%s %v',
        symbol: 'CHF',
        thousand: "'",
    },
    it_CH: {
        currency: 'CHF',
        decimal: ',',
        format: '%s %v',
        symbol: 'CHF',
        thousand: "'",
    },
    zh_CN: {
        currency: 'CNY',
        decimal: '.',
        format: '%s %v',
        symbol: '\u00A5',
        thousand: ',',
    },
    CY: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    de_DE: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_DK: {
        currency: 'DKK',
        decimal: ',',
        format: '%s %v',
        symbol: 'kr.',
        thousand: '.',
    },
    da_DK: {
        currency: 'DKK',
        decimal: ',',
        format: '%s %v',
        symbol: 'kr.',
        thousand: '.',
    },
    EE: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    es_ES: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_EU: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    fi_FI: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    fr_FR: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: ' ',
    },
    en_GB: {
        currency: 'GBP',
        symbol: '\u00A3',
    },
    el_GR: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_HK: {
        currency: 'HKD',
        symbol: 'HK$',
    },
    zh_HK: {
        currency: 'HKD',
        symbol: 'HK$',
    },
    IE: {
        currency: 'EUR',
        symbol: '\u20aC',
    },
    hr_HR: {
        currency: 'HRK',
        decimal: ',',
        format: '%v %s',
        symbol: 'kn',
        thousand: '.',
    },
    he_IL: {
        currency: 'ILS',
        decimal: '.',
        format: '%v %s',
        symbol: '₪',
        thousand: ',',
    },
    it_IT: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    ja_JP: {
        currency: 'JPY',
        symbol: '\u00A5',
    },
    fr_LU: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: ' ',
    },
    de_LU: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: ' ',
    },
    MC: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: ' ',
    },
    MT: {
        currency: 'MX',
        decimal: ',',
        symbol: '\u20aC',
        thousand: '.',
    },
    es_MX: {
        currency: 'MX',
        decimal: '.',
        symbol: '$',
        symbol_foreign: 'MX$',
        thousand: ',',
    },
    es_PR: {
        currency: 'USD',
        decimal: '.',
        symbol: '$',
        symbol_foreign: 'USD',
        thousand: ',',
    },
    en_PR: {
        currency: 'USD',
        decimal: '.',
        symbol: '$',
        symbol_foreign: 'USD',
        thousand: ',',
    },
    nl_NL: {
        currency: 'EUR',
        decimal: ',',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: '.',
    },
    no_NO: {
        currency: 'NOK',
        decimal: ',',
        format: '%s %v',
        symbol: 'kr.',
        thousand: '.',
    },
    en_NZ: {
        currency: 'NZD',
        decimal: '.',
        symbol: '$',
        symbol_foreign: 'NZ$',
        thousand: ',',
    },
    sv_SE: {
        currency: 'SEK',
        decimal: ',',
        format: '%v %s',
        symbol: 'kr',
        thousand: ' ',
    },
    pt_PT: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
    en_US: {
        currency: 'USD',
        decimal: '.',
        format: '%s%v',
        symbol: '$',
        thousand: ',',
    },
    en_ZA: {
        currency: 'ZAR',
        decimal: ',',
        symbol: 'R',
        thousand: '.',
    },
    en_IE: {
        currency: 'IRL',
        decimal: '.',
        format: '%s %v',
        symbol: '\u20aC',
        thousand: ',',
    },
    zh_MO: {
        currency: 'MAC',
        decimal: '.',
        symbol: 'HK$',
        thousand: ',',
    },
    en_MO: {
        currency: 'MAC',
        decimal: '.',
        position: 'prefix',
        symbol: 'HK$',
        thousand: ',',
    },
    SG: {
        currency: 'SGD',
        decimal: '.',
        format: '%s %v',
        symbol: '$',
        thousand: ',',
    },
    en_SG: {
        currency: 'SGD',
        decimal: '.',
        format: '%s %v',
        symbol: '$',
        thousand: ',',
    },
    zh_TW: {
        currency: 'TWN',
        decimal: '.',
        symbol: 'NT$',
        thousand: ',',
    },
    en_JO: {
        currency: 'JOD',
        decimal: '.',
        format: '%v %s',
        symbol: 'JOD',
        thousand: ',',
    },
    ko_KR: {
        currency: 'KRW',
        decimal: '.',
        symbol: '\u20A9',
        thousand: ',',
    },
    is_IS: {
        currency: 'ISK',
        decimal: ',',
        format: '%v %s',
        symbol: 'kr',
        thousand: '.',
    },
    pl_PL: {
        currency: 'PLN',
        decimal: ',',
        format: '%v %s',
        symbol: 'zł',
        thousand: '.',
    },
    sl_SI: {
        currency: 'EUR',
        decimal: ',',
        format: '%v %s',
        symbol: '\u20aC',
        thousand: '.',
    },
};

// @ts-ignore - No types for @tesla/validation
// default currency formatting options (passed to accounting.js)
var currency_default = {
    // This is custom, we add it.
    currency: 'USD',
    // decimal point separator
    decimal: '.',
    // controls output: %s = symbol, %v = value (can be object, see docs)
    format: '%s%v',
    // digit grouping (not implemented yet)
    grouping: 3,
    // precision (decimals)
    precision: 0,
    // default currency symbol is '$'
    symbol: '$',
    // thousands separator
    thousand: ',',
};
// default to US locale
var __locale = 'en_US';
var __thousandSymbol = ',';
var __decimalSymbol = '.';
var __precisionDefault = 0;
// contains all supported locale codes
var __supportedLocales = Object.keys(formats);
// caches format objects for faster lookups
var __cachedFormat = {};
/**
 * Gets normalized locale format object (fills in any missing properties from the default settings)
 */
function __getLocaleFormat(locale) {
    locale = locale || __locale;
    if (__cachedFormat[locale]) {
        return __cachedFormat[locale];
    }
    var fmt = null;
    var parsedLocale = parseLocale(locale);
    // TODO: rickyp - remove this after the next version of parseLocale
    if (parsedLocale == null) {
        fmt = __assign(__assign({}, currency_default), formats.en_US);
    }
    else if (formats[locale]) {
        // Attempt the locale directly passed in
        fmt = __assign(__assign({}, currency_default), formats[locale]);
    }
    else if (formats[parsedLocale.locale]) {
        // Attempt the locale determined by parseLocale
        fmt = __assign(__assign({}, currency_default), formats[parsedLocale.locale]);
    }
    else {
        // Attempt to match manually based on the country code
        for (var supportedLocale in formats) {
            if (supportedLocale.endsWith(parsedLocale.country)) {
                fmt = __assign(__assign({}, currency_default), formats[supportedLocale]);
                break;
            }
        }
    }
    // default to US if format object was not found for locale
    if (!fmt) {
        fmt = __assign(__assign({}, currency_default), formats.en_US);
    }
    __cachedFormat[locale] = fmt;
    return fmt;
}
var supportedLocales = __supportedLocales;
/**
 * Sets locale to use for formatting
 * @param {String} locale [standard locale language + country code in format of en_US, de_DE, etc...]
 */
var setLocale = function (locale) {
    __locale = locale;
};
/**
 * Formats number as currency according to current locale rules defined in number_format_config.json
 *
 * @param num
 * @param locale (optional) defaults to locale set in setLocale or en_US
 * @param opts {Object} (optional)
 */
var formatCurrency = function (num, locale, opts, postfix) {
    opts = opts || {};
    locale = locale || __locale;
    postfix = postfix || '';
    // opts was passed as 2nd argument, let's fix references
    if (typeof locale === 'object') {
        opts = locale;
        locale = __locale;
    }
    // update currency settings object
    accounting.settings.currency = __assign({}, __getLocaleFormat(locale));
    // if currency foreign exists in settings & a flag to display it is passed, default symbol to symbol foreign
    // @ts-ignore - Based on the typescript definition this doesn't exist but I'm afraid I'll break something
    var symbol_foreign = accounting.settings.currency.symbol_foreign;
    if (opts.showCurrSymbolForeign === true && symbol_foreign) {
        accounting.settings.currency.symbol = symbol_foreign;
    }
    // show currency symbol or not
    if (opts.showCurrSymbol === false) {
        accounting.settings.currency.symbol = '';
    }
    // set decimal places if sent as an arg, otherwise, use default setting.
    if (opts.precision) {
        accounting.settings.currency.precision = opts.precision;
    }
    // dynamic rounding means we round to a full number if it has 0 cents, but will show cents if cents != 0
    if (opts.dynamicRounding) {
        accounting.settings.currency.precision = num != null && Math.round(num) !== num ? 2 : 0;
    }
    // Run our values through the accounting formatMoney method if num is not undefined.
    if (num !== undefined) {
        if (num < 0) {
            return " - " + accounting.formatMoney(Math.abs(num), accounting.settings.currency) + postfix;
        }
        return accounting.formatMoney(num, accounting.settings.currency) + postfix;
    }
    return '';
};
/**
 * Returns formatted number
 */
var formatNumber = function (num, precision, locale) {
    locale = locale || __locale;
    precision = precision || __precisionDefault;
    var fmt = __getLocaleFormat(locale);
    var thousandSymbol = (fmt && fmt.thousand) || __thousandSymbol;
    var decimalSymbol = (fmt && fmt.decimal) || __decimalSymbol;
    // @ts-ignore - Not sure why typescript errors here but seems to test okay
    return accounting.formatNumber(num, precision, thousandSymbol, decimalSymbol);
};
/**
 * Returns number formatted as percent
 *
 * @param num
 * @param precision (how many decimal places?)
 * @param locale - locale region
 * @return {String}
 */
var formatPercent = function (num, precision, locale) {
    if (!precision && num < 1) {
        num = 100 * num;
    }
    return formatNumber(num, precision, locale) + "%";
};
/**
 * Returns format object for passed locale param
 * @param  {String} locale -- standard locale code: languageCode + '- ' + countryCode (en-US, de-DE, etc)
 * @return {Object}
 */
var getLocaleFormat = function (locale) {
    return __getLocaleFormat(locale);
};
/**
 * Sets the default number of decimals used to format currency
 * @param {Number} num -- number of decimals to format currency with (0|2)
 */
var setCurrencyPrecision = function (num) {
    if (num === 0 || num === 2) {
        currency_default.precision = num;
        __cachedFormat = {};
    }
};
/**
 * Returns a formated credit card number
 * @param num
 * @return {Number} num -- XXXX XXXX XXXX XXXX
 */
var formatCreditCard = function (value) {
    var creditCardValue = sanitizeNumberString(value);
    var cardType = CreditCard.getType(creditCardValue);
    var card = CreditCard.getTypeInfo(cardType);
    if (card) {
        var offsets = [0].concat(card.gaps).concat([creditCardValue.length]);
        var components = [];
        for (var i = 0; offsets[i] < creditCardValue.length; i++) {
            var start = offsets[i];
            var end = Math.min(offsets[i + 1], creditCardValue.length);
            components.push(creditCardValue.substring(start, end));
        }
        return components.join(' ');
    }
    return creditCardValue;
};
/**
 * Returns a formated Expiration Date
 * @param {String, Number} value
 * @param {String} format type
 * @return {String} formatted expration date (MM / YY)
 */
var formatExpirationDate = function (value, format) {
    if (format === void 0) { format = 'MM/YY'; }
    if (typeof value === 'number') {
        value = value.toString();
    }
    // clean value string
    var v = value.replace(/\s\/+/g, '').replace(/[^0-9]/gi, '');
    // if value is 5 digits, 1 digit month, 4 digit year
    if (v.length === 5) {
        v = "0" + v.substring(0, 1) + v.substring(3);
    }
    // assume 2 digit month, 4 digit year
    else if (v.length === 6) {
        v = v.substring(0, 2) + v.substring(4);
    }
    switch (format) {
        case 'MM/YY':
            var matches = v.match(/\d{2,4}/g);
            var match = (matches && matches[0]) || '';
            var parts = [];
            for (var i = 0, len = match.length; i < len; i += 2) {
                parts.push(match.substring(i, i + 2));
            }
            if (parts.length) {
                var joined = parts.join(' / ');
                if (joined.length === 2) {
                    return joined + " / ";
                }
                return joined;
            }
            return value;
    }
    return value;
};
/**
 * Returns a sanitized string
 * @param {String} num
 * @return {String} sanitized string
 */
var sanitizeNumberString = function (num) {
    var sanitizedNum;
    if (typeof num !== 'string') {
        sanitizedNum = num.toString();
    }
    else {
        sanitizedNum = num;
    }
    return sanitizedNum.replace(/[^\d]/g, '');
};

export { formatCreditCard, formatCurrency, formatExpirationDate, formatNumber, formatPercent, getLocaleFormat, sanitizeNumberString, setCurrencyPrecision, setLocale, supportedLocales };
